import PaymentStatusBadge from "./PaymentStatusBadge";

import {
  formatPaymentAmount,
  formatPaymentDate
} from "../utils/payment.utils";

const PaymentTable = ({
  payments,
  onView
}) => {
  if (!payments?.length) {
    return (
      <div className="payment-table__empty">
        No payments found.
      </div>
    );
  }

  return (
    <div className="payment-table-wrapper">
      <table className="payment-table">
        <thead>
          <tr>
            <th>Offer</th>
            <th>Amount</th>
            <th>Gateway</th>
            <th>Status</th>
            <th>Created</th>
            <th>Paid At</th>
            <th>Action</th>
          </tr>
        </thead>

        <tbody>
          {payments.map(
            (payment) => (
              <tr
                key={payment.id}
              >
                <td>
                  {payment.offer_number ||
                    "—"}
                </td>

                <td>
                  {formatPaymentAmount(
                    payment.amount,
                    payment.currency
                  )}
                </td>

                <td>
                  {payment.gateway ||
                    "—"}
                </td>

                <td>
                  <PaymentStatusBadge
                    status={
                      payment.status
                    }
                  />
                </td>

                <td>
                  {formatPaymentDate(
                    payment.created_at
                  )}
                </td>

                <td>
                  {formatPaymentDate(
                    payment.paid_at
                  )}
                </td>

                <td>
                  <button
                    type="button"
                    onClick={() =>
                      onView(
                        payment.id
                      )
                    }
                  >
                    View
                  </button>
                </td>
              </tr>
            )
          )}
        </tbody>
      </table>
    </div>
  );
};

export default PaymentTable;
